(function(){
  'use strict';

  angular.module('clientDashboardApp.admin.forms.phoneValidation',[]).directive('phoneValidation',PhoneValidation);

  function PhoneValidation() {
    return {
      require: "ngModel",
      scope: {
        minDigits : "=",
        maxDigits : "=",
        errorType : "=",
        country : "="
      },
      link: function (scope, element, attrs, ctrl) {
        function validate(viewValue) {
          const USPhones = ["US","CA"]
          const usPhoneRegex=/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/ //used for US and Canada
          const outsideUS=/\d+/ //used for outside the US
          let regexToUse = usPhoneRegex
          if(!USPhones.includes(scope.country)){
            regexToUse=outsideUS
          }
          const passedCheck = regexToUse.test(viewValue)
          if (viewValue && viewValue.length > 0 && ! passedCheck) {
            ctrl.$setValidity('string', false);
          } else {
            ctrl.$setValidity('string', true);
          }
          return viewValue;
        }

        ctrl.$parsers.unshift(validate);
        ctrl.$formatters.unshift(validate);
      }
    }
  }
})();

